import { JsonObject, JsonValue } from '@bufbuild/protobuf';
import { pb } from '@q6cyber/proto2es';
import { cloneDeep } from 'lodash';

import { FormControl, FormGroup } from '@angular/forms';

export const DEFAULT_COMMENT = new pb.common.Comment().toJson({
  emitDefaultValues: true,
}) as unknown as pb.common.Comment | JsonValue;

export const commentsForm = (data = cloneDeep(DEFAULT_COMMENT)) => {
  const form = new FormGroup({
    name: new FormControl(''),
    comment: new FormControl(''),
    edited: new FormControl(false),
    timestamp: new FormControl(null as null | string),
  });
  form.patchValue({
    ...(data as JsonObject),
  });
  return form;
};

export type CommentFormGroup = ReturnType<typeof commentsForm>;
